import type { IFrontendServiceContainer } from '@phi/frontend/service-container';
import type { SessionType } from '../state';
import type { Session } from '@phi/session';
import { add1 } from '@vaaas/fpts/set';
import { getUser } from '@phi/frontend/api/calls';

export const authenticate_through_phi_provider = (app: IFrontendServiceContainer) => async (id: Session['id']) => {
    app.authentication.session_type.value = add1('phi' as SessionType)(app.authentication.session_type.value);
    app.device_storage.token = id;

    await getUser().then(x => {
        if (x instanceof Error)
            return undefined;
        app.state.user = x;
        Object.assign(app.settings, x.settings);
    });

    await app.authentication.validate_session();

    if (!app.state.user?.stripe_subscription_id)
        app.subscriptions.show_select_a_subscription_page();
    else {
        app.pop_under_with_router.hide_pop_under();
        app.state.should_load_app = true;
    }
};
